import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class clockModel extends Model {

    defaults() {
        return {
	        inBuiltApi: Vue.prototype.$interpretersApiUrl
        }
    }

    options() {
        return {
            methods: {
                clockoff: 'POST',
                clockon: 'POST',
	            healthDeclaration: 'GET',
	            healthDeclarationRejected: 'POST',
	            healthDeclarationAcknowledged: 'POST'
            }
        }
    }

    routes() {
        return {
            clockoff: 'interpreter/clockoff',
            clockon: 'interpreter/clockon',
	        healthDeclaration: 'interpreter/clockon/condition',
	        healthDeclarationRejected: 'interpreter/clockon/rejected',
	        healthDeclarationAcknowledged: 'interpreter/clockon/acknowledged'
        }
    }

    clockActivityFunc(activity, data) {
        let route = '';
        let method = '';
        if (activity == 'clockon') {
            route = Vue.prototype.$apiAllGraduatesUrl + this.getRoute('clockon');
            method = this.getOption('methods.clockon');
        }
        else if (activity == 'clockoff') {
            route = Vue.prototype.$apiAllGraduatesUrl + this.getRoute('clockoff');
            method = this.getOption('methods.clockoff');
        }
        else if (activity == 'Health Declaration') {
            route = Vue.prototype.$apiAllGraduatesUrl + this.getRoute('healthDeclaration') + '?' +
	            'jobID=' + data.jobID +
	            '&serviceDate=' + data.serviceDate;
            method = this.getOption('methods.healthDeclaration');
        }
        else if (activity == 'Health Declaration Rejected') {
	        route = Vue.prototype.$apiAllGraduatesUrl + this.getRoute('healthDeclarationRejected');
	        method = this.getOption('methods.healthDeclarationRejected');
        }
        else if (activity == 'Health Declaration Acknowledged') {
	        route = Vue.prototype.$apiAllGraduatesUrl + this.getRoute('healthDeclarationAcknowledged');
	        method = this.getOption('methods.healthDeclarationAcknowledged');
        }
        else {
        	return
        }

        let headers = {
            Bearer: localStorage.getItem('jwt')
        };

	    let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url, data}).send();
    }
}
